import {ORGANIZATION_SERVER} from "@/api";
import RestResource from "@/api/rest/rest-resource";

const userGroup = new RestResource({server: ORGANIZATION_SERVER, resource: 'userGroup'});

export default userGroup;